module.exports = "/img/icon-life.svg?469cdf88e4e7fa597727d5a16e0ae1da";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/icon-life.svg
// module id = HZn6
// module chunks = 46